import Vue from 'vue'
import Vuex from 'vuex'

import geolocation from './geolocation'
import storage from './storage'
import map from './map'
import plant from './plant'
import survey from './survey'
import type from './type'
import user from './user'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        geolocation,
        storage,
        map,
        plant,
        survey,
        type,
        user,
    }
})
